import { loadStripe, Stripe } from '@stripe/stripe-js';

const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

// Log for debugging
console.log('Stripe publishable key status:', publishableKey ? 'Set (length: ' + publishableKey.length + ')' : 'Not set');

let stripePromise: Promise<Stripe | null> | null = null;

export const getStripePromise = (): Promise<Stripe | null> | null => {
  if (!publishableKey) {
    console.error('REACT_APP_STRIPE_PUBLISHABLE_KEY is not set');
    return null;
  }

  if (!stripePromise) {
    stripePromise = loadStripe(publishableKey);
  }

  return stripePromise;
};

export const createPaymentIntent = async (
  amount: number,
  customerEmail: string,
  metadata: any
) => {
  console.log('📡 Calling payment intent API with:', {
    amount,
    customerEmail,
    metadata,
  });

  try {
    const response = await fetch(
      'https://createpaymentintent-p5jukntvxa-uc.a.run.app',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          amount: Math.round(amount * 100), // Convert to cents
          currency: 'eur',
          customer_email: customerEmail,
          metadata,
        }),
      }
    );

    console.log('📡 API Response status:', response.status);

    if (!response.ok) {
      const errorData = await response.text();
      console.error('❌ API Error response:', errorData);
      throw new Error(`Failed to create payment intent: ${response.status} - ${errorData}`);
    }

    const data = await response.json();
    console.log('✅ API Success response:', data);
    return data;
  } catch (error) {
    console.error('💥 Network error calling payment intent API:', error);
    throw error;
  }
};
